import React from 'react';
import { useTranslation } from 'react-i18next';
import StyledButton from './StyledButton';
import styled from '@emotion/styled';

const StyledSubmitButton = styled(StyledButton)({
  backgroundColor: "#2B80B6",
  color: "#ffffff !important",
  "&.MuiButton-root": { color: "#ffffff !important" },
  "& .MuiButton-label": { color: "#ffffff !important" },
  boxShadow: "2px 2px 4px rgba(0,0,0,0.1), -2px -2px 4px rgba(255,255,255,0.7)",
  "&:hover": {
    backgroundColor: "#2C6B8C",
    boxShadow: "inset 4px 4px 8px #0561ad, inset -4px -4px 8px #0561ad",
    color: "#ffffff !important",
    "& .MuiButton-label": { color: "#ffffff !important" },
  },
  "&.Mui-disabled": {
    color: "rgba(255,255,255,0.7) !important",
    "& .MuiButton-label": { color: "rgba(255,255,255,0.7) !important" },
  },
  fontWeight: 400,
  fontSize: "12.5px",
  fontFamily: "Fira Sans, Helvetica Neue, Helvetica, Roboto, Arial, sans-serif",
});

const SubmitButton = ({ children, color, variant, ...props }) => {
  const { t } = useTranslation('buttons');

  return (
    <StyledSubmitButton
      {...props}
      variant="contained"
      color="inherit"
    >
      {children || t('submit')}
    </StyledSubmitButton>
  );
};

export default SubmitButton;